import API from 'services/API';

// -- Liste complète (Admin / CPSAdmin)
export const getCourses = () => API.get('/course');

// -- Courses accessibles à l'utilisateur courant
export const getMyCourses = () => API.get('/course/mine');

// -- Course sélectionnée (courante) de l'utilisateur
export const getCurrentCourse = () => API.get('/course/current');

// -- Changement de course courante (Admin / CPSAdmin)
export const selectCourse = courseId => API.post('/course/select', { courseId });

// -- CRUD (Admin / CPSAdmin)
export const createCourse = formData => API.post('/course', formData);

export const updateCourse = (id, formData) => API.patch(`/course/${id}`, formData);

export const deleteCourse = id => API.delete(`/course/${id}`);

// -- Accès utilisateurs (Admin / CPSAdmin)
export const getCourseUsers = courseId => API.get(`/course/${courseId}/users`);

export const setCourseUsers = (courseId, userIds) => API.put(`/course/${courseId}/users`, { userIds });

// -- Duplication (Admin / CPSAdmin)
export const duplicateCourse = (sourceCourseId, formData) => API.post(`/course/${sourceCourseId}/duplicate`, formData);
